import { render, staticRenderFns } from "./BreadcrumbBanner.vue?vue&type=template&id=22e10e2c&"
import script from "./BreadcrumbBanner.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports